/* eslint-disable eqeqeq */
import BootstrapTable from "react-bootstrap-table-next";
import {
  paymentMethods,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { getModuleNamingBySlug } from "../../lib/Misc";
import { formatSubcontractorName, formatNumber } from "../../lib/Misc";
import { cn } from "../../lib/utils";
import { LawyerConditon } from "../../lib/PermissionConditions";

const ExpandReceipt = ({ expandData }) => {
  const { organizationData } = useOrganization();
  const expandDataGenerator = (quantity) => {
    const items = [];
    // if (expandData.allocation_date) {
    //   items.push({
    //     key: expandData?.id,
    //     status: "Allocated",
    //     transaction_date: expandData?.allocation_date
    //       ? expandData?.allocation_date
    //       : "-",

    //     description: "Refundable deposite allocated to vendor",
    //     vendor: expandData?.vendor ? expandData?.vendor : "-",
    //     asset: expandData?.asset ? expandData?.asset : "-",
    //     sub_asset: expandData?.sub_asset ? expandData?.sub_asset : "-",
    //     contract: expandData?.contract
    //       ? expandData?.contract?.contract_number
    //       : "-",
    //     job: expandData?.job ? expandData?.job : "-",
    //     task: expandData?.task ? expandData?.task : "-",
    //   });
    // }

    // if (expandData.refunded_date) {
    //   items.push({
    //     key: expandData?.id,
    //     status: "Refunded",
    //     transaction_date: expandData?.refunded_date
    //       ? expandData?.refunded_date
    //       : "-",

    //     description: "Deposit Amount Refunded",
    //     vendor: expandData?.vendor ? expandData?.vendor : "-",
    //     asset: expandData?.asset ? expandData?.asset : "-",
    //     sub_asset: expandData?.sub_asset ? expandData?.sub_asset : "-",
    //     contract: expandData?.contract
    //       ? expandData?.contract?.contract_number
    //       : "-",
    //     job: expandData?.job ? expandData?.job : "-",
    //     task: expandData?.task ? expandData?.task : "-",
    //   });
    // }

    for (let i = 0; i < quantity; i++) {
      items.push({
        key: expandData?.[i]?.id,
        payment_method: expandData[i]?.payment_method
          ? expandData[i]?.payment_method == "5"
            ? "JE"
            : paymentMethods?.find(
                (item) => item.value === Number(expandData[i]?.payment_method)
              )?.label
          : "-",
        description: expandData?.[i]?.description
          ? expandData?.[i]?.description
          : "-",
        vendor: expandData?.[i]?.vendor
          ? formatSubcontractorName(expandData?.[i]?.vendor)
          : "-",
        asset: expandData?.[i]?.asset ? expandData?.[i]?.asset?.name : "-",
        sub_asset: expandData?.[i]?.sub_asset
          ? expandData?.[i]?.sub_asset?.name
          : "-",
        contract: expandData?.[i]?.contract
          ? expandData?.[i]?.contract?.contract_number
          : "-",
        job: expandData?.[i]?.job ? expandData?.[i]?.job?.code : "-",
        task: expandData?.[i]?.task ? expandData?.[i]?.task?.code : "-",
        amount: expandData[i]?.amount ? (
          <b>${formatNumber(Number(expandData[i]?.amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        remaining_balance: expandData[i]?.remaining_balance ? (
          <b>${formatNumber(Number(expandData[i]?.remaining_balance))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
      });
    }

    return items;
  };

  const subExapndData = expandDataGenerator(expandData?.length);

  let columns = [
    {
      headerClasses: cn(
        THClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      classes: cn(
        TDClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      dataField: "description",
      text: LawyerConditon(organizationData)
        ? "Matter Description"
        : "Description",
    },
    {
      headerClasses: cn(
        THClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      classes: cn(
        TDClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      dataField: "vendor",
      text: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "vendors",
        "Vendor"
      )}`,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "asset",
      text: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "assets",
        "Asset"
      )}`,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "sub_asset",
      text: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "sub-assets",
        "Sub Asset"
      )}`,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "contract",
      text: "Contract",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "job",
      text: "Job",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "task",
      text: "Task",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "payment_method",
      text: "Payment Method",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "amount",
      text: "Amount (Inc)",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "remaining_balance",
      text: "Remaining Balance",
    },
  ];

    if (LawyerConditon(organizationData)) {
    columns = columns?.filter(
      (item) => item.dataField !== "job" && item.dataField !== "task"
    );
  }

  return (
    <>
      <div className="custom-table p-2">
        <div className={"table-body-class"}>
          <BootstrapTable
            keyField="key"
            remote
            data={subExapndData}
            columns={columns}
            rowClasses={TRClasses}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>
      </div>
    </>
  );
};

export default ExpandReceipt;
